import { PalmettoIcon, PalmettoProgressCircular } from '@palmetto/dsm-components';
import { Box, BoxProps } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { HoverOnlyTooltipComponent } from '../Tooltip';

const dottedUnderlineStyle = { borderBottom: '1px dotted currentColor' } as const;
const settingLinkStyle = { textDecoration: 'underline dotted', color: 'inherit' } as const;
const noWrapStyle = { whiteSpace: 'nowrap' } as const;
const noop = () => {};
const triggerStyle: BoxProps = { display: 'inline-flex', alignItems: 'center' };
const tooltipContentStyle: BoxProps = { width: '3xl', background: 'inverse' };
const tooltipContainerStyle: BoxProps = { background: 'inverse', color: 'inverse-secondary' };

function SettingLink({ orgAlias }: { orgAlias: string }) {
  return (
    <Box display="inline" style={noWrapStyle}>
      <Link to={`/settings/organizations/${orgAlias}/capacity`} style={settingLinkStyle}>
        setting
      </Link>
      .
    </Box>
  );
}

interface ForecastVolumeIndicatorProps {
  forecastPercentage: number;
  leadsRemaining: number;
  allowExceed: boolean;
  orgAlias: string;
}

export function ForecastVolumeIndicator({
  forecastPercentage,
  leadsRemaining,
  allowExceed,
  orgAlias,
}: ForecastVolumeIndicatorProps) {
  return (
    <Box direction="row" alignItems="center" gap="sm">
      <HoverOnlyTooltipComponent
        content={
          <>
            {leadsRemaining} left for the month. To change your capacity, go to <SettingLink orgAlias={orgAlias} />
          </>
        }
        onClose={noop}
        displayedContainerStyle={triggerStyle}
        tooltipContainerStyle={tooltipContainerStyle}
        contentStyle={tooltipContentStyle}
      >
        <Box direction="row" alignItems="center" childGap="sm">
          <PalmettoProgressCircular percentage={forecastPercentage} size="md" />
          <Box fontSize="sm" fontWeight="medium" color="body-secondary" style={dottedUnderlineStyle}>
            monthly forecast volume reached
          </Box>
        </Box>
      </HoverOnlyTooltipComponent>

      <HoverOnlyTooltipComponent
        content={
          <>
            You won&apos;t receive leads once you reach forecast volume. To change that, go to{' '}
            <SettingLink orgAlias={orgAlias} />
          </>
        }
        onClose={noop}
        displayedContainerStyle={triggerStyle}
        tooltipContainerStyle={tooltipContainerStyle}
        contentStyle={tooltipContentStyle}
      >
        <Box
          direction="row"
          alignItems="center"
          childGap="2xs"
          fontSize="sm"
          fontWeight="medium"
          color="body-secondary"
        >
          <Box style={dottedUnderlineStyle}>Allow exceed:</Box>
          <PalmettoIcon name={allowExceed ? 'check' : 'x'} size="md" />
          <Box>{allowExceed ? 'On' : 'Off'}</Box>
        </Box>
      </HoverOnlyTooltipComponent>
    </Box>
  );
}
